export const FETCH_ACCOUNTS = "[RECEPTIONIST] FETCH_ACCOUNTS";
export const FETCH_ACCOUNTS_SUCCESS = "[RECEPTIONIST] FETCH_ACCOUNTS_SUCCESS";
export const FETCH_ACCOUNTS_ERROR = "[RECEPTIONIST] FETCH_ACCOUNTS_ERROR";

export const SEARCH_ACCOUNTS = "[RECEPTIONIST] SEARCH_ACCOUNTS";
export const SEARCH_ACCOUNTS_SUCCESS = "[RECEPTIONIST] SEARCH_ACCOUNTS_SUCCESS";
export const SEARCH_ACCOUNTS_ERROR = "[RECEPTIONIST] SEARCH_ACCOUNTS_ERROR";

export const SET_ACTIVE_TAB = "[ACCOUNTS] SET_ACTIVE_TAB";

export const REMOVE_VISIT = "[ACCOUNTS] REMOVE_VISIT";
export const REMOVE_INVOICE_ITEM = "[ACCOUNTS] REMOVE_INVOICE_ITEM";
export const UPDATE_CLAIM_PAYMENT_DATA = "[ACCOUNTS] UPDATE_CLAIM_PAYMENT_DATA";
export const UPDATE_CLAIM_SERVICE = "[ACCOUNTS] UPDATE_CLAIM_SERVICE";
export const UPDATE_ACCOUNTS_CONFIG = "[RECEPTIONIST] UPDATE_ACCOUNTS_CONFIG";

export const fetchAccounts = ({ requestPayload, tab }) => {
  return {
    type: FETCH_ACCOUNTS,
    payload: { requestPayload, tab },
  };
};

export const searchAccounts = (payload) => {
  return {
    type: SEARCH_ACCOUNTS,
    payload: payload,
  };
};

export const setActiveTab = (tab) => ({
  type: SET_ACTIVE_TAB,
  payload: tab,
});

export const removeVisit = (visitId) => ({
  type: REMOVE_VISIT,
  payload: visitId,
});

export const removeInvoiceItem = (invoiceItems) => ({
  type: REMOVE_INVOICE_ITEM,
  payload: invoiceItems,
});

export const updateClaimPaymentData = ({
  claimId,
  claimStatus,
  claimPaymentStatus,
  paymentRunDate,
  paymentRunNumber,
}) => ({
  type: UPDATE_CLAIM_PAYMENT_DATA,
  payload: {
    claimId,
    claimStatus,
    claimPaymentStatus,
    paymentRunDate,
    paymentRunNumber,
  },
});

export const updateClaimService = ({ service, tab }) => {
  return {
    type: UPDATE_CLAIM_SERVICE,
    payload: { service, tab },
  };
};

export const updateAccountsConfig = (config) => {
  return {
    type: UPDATE_ACCOUNTS_CONFIG,
    payload: config
  }
}
